import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { DeviceDetectorService } from 'ngx-device-detector';
import { APIService } from 'src/app/services/api.service';

@Component({
  selector: 'app-four-pillars',
  templateUrl: './four-pillars.component.html',
  styleUrls: ['./four-pillars.component.scss'],
  standalone: false,
})
export class FourPillarsComponent {
  logoUrl: any;
  slideInt: any;
  slideInterval = 100;
  infiniteSlide = true;
  selectedIndex = 0;

  imageSize = {
    width: '80px',
    height: '80px',
    space: 12,
  };
  imageSizeMobile = {
    width: '58px',
    height: '58px',
    space: 6,
  };

  autoSlide = { interval: 1, stopOnHover: true };

  userCards: any = [
    {
      imgsrc:
        'https://res.cloudinary.com/inforida-in/image/upload/c_scale,h_105/v1524555310/user-male-icon.png',
      name: 'Mr. Jai Singh, Principal',
      school: 'Saraswati Shishu Mandir, Lakhimpur',
      description: `I was initially hesitant to take the software due to no technical knowledge, but within few days of using it, Inforida team has made me comfortable with the software and now I am so much dependent on it while managing my institution.`,
    },
    {
      imgsrc:
        'https://res.cloudinary.com/inforida-in/image/upload/c_scale,h_105/v1524555310/user-female-icon.png',
      name: 'Mrs. Shivani Awasthi, Principal',
      school: 'Sanik Sanjeevani Public School, Sitapur',
      description: `The most economical and user friendly School Management System, Our School Staff is using it from past three years and found it surprisingly easy to use. The interface for School Admin, Accountant, Teachers, parents and student is attractive and very easy to follow.`,
    },
    {
      imgsrc: 'https://my.inforida.com/assets/images/sakal.png',
      name: 'Mr. Sanjay Singh, Owner',
      school: 'Sakalnarayan Memorial Public School, Raebareli',
      description: `Our school was loosing ₹10-15 Lacks every acedemic session.
      Thanks to Inforida now I can manage, view and download all financial reports in one click from anywhere. We are using Inforida from last 4 years and never had any problems.`,
    },
    {
      imgsrc: 'https://my.inforida.com/assets/images/mkd.png',
      name: 'Mr. Priyansh Dixit, Owner',
      school: 'Saraswati Shishu Mandir, Lakhimpur',
      description: `The customer support team is super fast and attempts to solve every query/issue. Very easy to use, great school management system with an innovative approach for every problem faced in school administration.
      `,
    },
  ];

  featuresCard = [
    {
      title: 'People',
      // description:
      //   'Empower Your Staff With A <b>Dedicated App</b> To Seamlessly Perform Their Tasks And Boost Productivity.',
      description: [
        'Empower Your Staff With A <b> Dedicated App</b> To Seamlessly Perform Their Tasks and Boost Productivity',
        'Ensure data Privacy & security with <b>RBAC</b> (Role-Based access Control)',
      ],
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-main-image1.png',
      isReversed: false,
    },
    {
      title: 'Finance',
      description: [
        'keep track of your <b>income</b> & <b>expenses</b> and access them instantly from a single dashboard',
        'View <b>Real-time</b> Financial reports for better planning',
        'Facilitate fee <b>collection</b>, <b>discounts</b>, and <b>Fee reminders</b>',
      ],
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-main-image3.png',
      isReversed: true,
    },
    {
      title: 'Classroom',
      description: [
        'Streamline classroom operations with tools which enable Schools to improve <b>productivity</b> & <b>simplify</b> daily Operations',
        'Foster </b>better learning outcomes<b> for students by providing <b>actionable insights</b>',
      ],
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-main-image4.png',
      isReversed: false,
    },
    {
      title: 'Communication',
      description: [
        'Improve engagement with <b>seamless communication</b> that keeps <b>staff</b> connected, and <b>parents</b> in sync',
        'Enable transparency with <b>real-time communication</b> across multiple channels in your school Ecosystem',
      ],
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/communication-image.jpg',
      isReversed: true,
    },
  ];

  constructor(
    private deviceService: DeviceDetectorService,
    public apiService: APIService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.getLogo();
    if (isPlatformBrowser(this.platformId)) {
      this.slideInt = setInterval(() => {
        this.nextslide();
      }, this.slideInterval);
    }
  }

  ngOnDestroy(): void {
    if (this.slideInt) {
      clearInterval(this.slideInt);
    }
  }

  getLogo() {
    this.apiService.getSchoolLogo().subscribe((res: any) => {
      this.logoUrl = res;
    });
    if (this.logoUrl.length) {
      let thumbSize = 'h_280,w_360';
      let finalSize = 'h_800';

      this.logoUrl = this.logoUrl.map((img: any) => {
        img.thumbImage = this.transformImageSize(img.url, thumbSize);
        img.image = this.transformImageSize(img.url, finalSize);
        img.alt = '';
        img.title = '';
        return img;
      });
    }
  }

  transformImageSize(url, size) {
    if (url && url.length && url.includes('cloudinary')) {
      const urlSplit = url.split('/upload/');
      return `${urlSplit[0]}/upload/${size}/${urlSplit[1]}`;
    }
    return url;
  }

  nextslide() {
    if (this.selectedIndex === this.userCards.length - 1) {
      this.selectedIndex = 0;
    } else {
      this.selectedIndex = this.selectedIndex + 1;
    }
  }

  animationCreated(animationItem: AnimationItem): void {
    animationItem.setSpeed(8);
    console.log(animationItem);
  }

  getImgSize() {
    if (this.isMobile()) {
      return this.imageSizeMobile;
    } else {
      return this.imageSize;
    }
  }

  isMobile(): boolean {
    return this.deviceService.isMobile();
  }

  goToPage() {
    const url =
      'https://cal.com/inforida-demo/30min?month=2025-01&date=2025-01-18';
    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
  }
}
